// extracted by mini-css-extract-plugin
export var billingAddress = "_y9-g";
export var contactInfo = "_y9-d";
export var customerInfoContainer = "_y9-c";
export var customerInfoContainerMobile = "_y9-h";
export var customerInfoRow = "_y9-a";
export var customerInfoSection = "_y9-b";
export var fullWidthDividerMobile = "_y9-i";
export var imageContainer = "_y9-1";
export var paymentMethod = "_y9-e";
export var priceText = "_y9-6";
export var priceTextMobile = "_y9-7";
export var product = "_y9-0";
export var productImage = "_y9-2";
export var productInfo = "_y9-4";
export var productMobile = "_y9-9";
export var productTitle = "_y9-8";
export var quantityBadge = "_y9-3";
export var quantityText = "_y9-5";
export var shippingAddress = "_y9-f";